<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6QhwOz/tc-custom/9781429947244.jpg?1729034189907" alt="This image is the cover for the book Entity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Entity
      </h1>
      <p class="bookDescription body article font2">
        <b> International Bestseller: “Meticulously documented . . . Frattini gives us an exclusive look at the hidden face of the papacy—revelations that send a chill up the spine.” —<i>Le Monde</i></b><br/><br/>For five centuries, the Vatican—the oldest organization in the world, maker of kings and shaper of history—has used a secret spy service, called the Holy Alliance, or later, the Entity, to carry out its will. Forty popes have relied on it to carry out their policies. They have played a hitherto invisible role confronting de-Christianizations and schisms, revolutions and dictators, colonizations and expulsions, persecutions and attacks, civil wars and world wars, assassinations and kidnappings.<br/><br/>For the first time in English (following the bestselling Spanish and French editions), Eric Frattini tells the comprehensive tale of this sacred secret service. The Entity has been involved in the killings of monarchs, poisonings of diplomats, financing of South American dictators, protection of war criminals, laundering of Mafia money, manipulation of financial markets, provocation of bank failures, and financing of arms sales to combatants even as their wars were condemned, all in the name of God. The contradiction between God’s justice and Earth’s justice, Christian beliefs and Christian power all fall before the motto of the Entity: With the Cross and the Sword.<br/><br/><b>“A true story that surpasses any novel by John le Carré.” —<i>El País</i> (Spain)</b><br/><br/><b>“An investigation worthy of a Pulitzer. Frattini puts all the secrets of the Vatican out on the table.” —<i>Diário de Notícias</i> (Portugal)</b><br/><br/><b>“A devastating book.” —<i>Valeurs</i> (France)</b><br/><br/><b>“A must-read.” —<i>El Universal</i> (Mexico)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Frattini, Dick Cluster
      </h2>
      
      <p class="authorDescription body article"><P><B>Eric Frattini</B> has written books on the FBI, the UN, and the CIA, and is the author of <I>Mafia Inc.: 100 Years of Cosa Nostra</I>. He is a TV correspondent and lives in Spain.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cad9f054